import React, { useEffect } from 'react';
import Layout from '../../components/layout/layout';
import { WebPageSchema, BreadcrumbSchema } from '../../lib/utils/schema-utils';

export default function ContactPage() {
  useEffect(() => {
    const loadHubspotForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "4621272",
          formId: "359a2885-18f8-415d-adfb-f8e4e9cd36dd",
          target: "#hubspot-form"
        });
      }
    };

    // Si le script est déjà là, on appelle directement
    if (window.hbspt) {
      loadHubspotForm();
    } else {
      // Sinon on attend que le script se charge
      const interval = setInterval(() => {
        if (window.hbspt) {
          clearInterval(interval);
          loadHubspotForm();
        }
      }, 100);
    }
  }, []);

  return (
    <Layout
      title="Nous écrire - Recruteurs.io"
      description="Vous avez une question, une intuition, un projet en tête ? Parlez-nous vrai. On vous répondra avec autant d'humanité que de méthode."
    >
      <WebPageSchema
        page={{
          title: "Nous écrire - Recruteurs.io",
          description: "Vous avez une question, une intuition, un projet en tête ? Parlez-nous vrai. On vous répondra avec autant d'humanité que de méthode.",
          url: "https://recruteurs.io/contact"
        }}
      />

      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://recruteurs.io" },
          { name: "Contact", url: "https://recruteurs.io/contact" }
        ]}
      />

      <section className="py-24 px-6 text-center bg-gradient-to-r from-[#f5e9dc] via-[#ffe4ed] to-[#e6f1ff] rounded-b-3xl">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
            Nous écrire, c'est déjà commencer
          </h1>
          <p className="text-lg md:text-xl text-neutral-700 mb-8">
            Une question. Une friction. Un alignement à retrouver.  
            Écrivez-nous sans filtre.  
            On ne traite pas des leads, on écoute des gens.
          </p>
        </div>
      </section>

      <section className="py-16 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div id="hubspot-form" />
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-[#f8f9fa]">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-xl text-neutral-600">
            Vous pouvez aussi venir nous voir.  
            Pas dans une tour de verre, mais au cœur du village.
          </p>
          <p className="text-2xl font-bold text-neutral-800">
            11 chemin du Mont Gibaou, 13260 Cassis
          </p>
          <p className="text-lg text-neutral-500 italic">
            Ici, il y a des marins et des terriens. Ancrés. Humains.  
            Les pieds dans la roche calcaire, les yeux au large.
          </p>
        </div>
      </section>
    </Layout>
  );
}